export default {
  meta: {
    title: '踩点分析设置',
    url: '/footprinting/analysis', // 埋点用，记录所属模块
    // eventId: 'c2fa9fd0-2a61-4d46-be2a-218244a463c1'
  },
};
